import { MdArrowOutward } from "react-icons/md";

export default function ArrowTopRight({size}) {
    return <MdArrowOutward size={size} />;
}